<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Assign a country's network</h2>
  <p class="dialog-subtitle">Decide which blockchain a country's companies write to.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <app-country-select label="Country" [(ngModel)]="countryCode" name="countryCode" />

  <mat-form-field appearance="outline">
    <mat-label>Network</mat-label>
    <input matInput [(ngModel)]="network" name="network" placeholder="MY_BLOCKCHAIN" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Schema profile (optional)</mat-label>
    <input matInput [(ngModel)]="schemaProfile" name="schemaProfile" placeholder="DICTIONARY" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
